import { useNavigate } from 'react-router-dom';

const trackClick = (source: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'for_sale_click', { source });
  }
};

const ForSaleCalculatorBlock = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    trackClick('calculator_block');
    navigate('/for-sale');
  };

  return (
    <div className="mt-6 border-2 border-red-500 rounded-xl overflow-hidden shadow-lg shadow-red-100">
      {/* Red header bar */}
      <div className="bg-red-600 px-5 py-3 flex items-center gap-2">
        <i className="ri-price-tag-3-fill text-yellow-300 text-lg"></i>
        <span className="text-white font-black text-sm tracking-wide uppercase">Website For Sale</span>
      </div>

      {/* Card body */}
      <div className="bg-white px-5 py-5">
        <h3 className="text-gray-900 font-bold text-xl mb-1">🚨 This Website Is For Sale</h3>
        <p className="text-gray-500 text-sm mb-4">
          Acquire a fully operational, SEO-optimized salary calculator with 200+ city pages and growing traffic.
        </p>

        <ul className="space-y-2 mb-5">
          {[
            { icon: 'ri-line-chart-line', text: 'Built for SEO traffic — 200+ indexed pages' },
            { icon: 'ri-money-dollar-circle-line', text: 'Monetization-ready (AdSense, affiliates)' },
            { icon: 'ri-dashboard-3-line', text: 'Admin dashboard included — no code needed' },
            { icon: 'ri-global-line', text: 'US + UK coverage, evergreen niche' },
          ].map((item, i) => (
            <li key={i} className="flex items-start gap-2.5">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                <i className={`${item.icon} text-red-500 text-base`}></i>
              </div>
              <span className="text-gray-700 text-sm">{item.text}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={handleClick}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm flex items-center justify-center gap-2"
        >
          <i className="ri-briefcase-4-line"></i>
          Own This Website — View Acquisition Details
        </button>
      </div>
    </div>
  );
};

export default ForSaleCalculatorBlock;
